import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enProductTranslation from './locales/en/product.json';
import enOnboardingTranslation from './locales/en/onboarding.json';
import enLayoutComponents from './locales/en/layoutComponents.json';
import enApiErrors from './locales/en/apiErrors.json';
import enGlobalComponents from './locales/en/globalComponents.json';
import enBundleComponentTranslation from './locales/en/bundle.json';
import enShopTranslation from './locales/en/shop.json';
import enApprovalComponentTranslation from './locales/en/approval.json';
import enOrdersTranslation from './locales/en/orders.json';
import enAuthentication from './locales/en/authentication.json';
import enPhoneNumberVerification from './locales/en/phoneNumberVerification.json';
import enAssets from './locales/en/assets.json';
import enEditOrganization from './locales/en/organizationEdit.json';
import enQuestionAndAnswers from './locales/en/questionsAndAnswers.json';

import noProductTranslation from './locales/no/product.json';
import noOnboardingTranslation from './locales/no/onboarding.json';
import noLayoutComponents from './locales/no/layoutComponents.json';
import noApiErrors from './locales/no/apiErrors.json';
import noGlobalComponents from './locales/no/globalComponents.json';
import noBundleComponentTranslation from './locales/no/bundle.json';
import noShopTranslation from './locales/no/shop.json';
import noApprovalComponentTranslation from './locales/no/approval.json';
import noOrdersTranslation from './locales/no/orders.json';
import noAuthentication from './locales/no/authentication.json';
import noPhoneNumberVerification from './locales/no/phoneNumberVerification.json';
import noAssets from './locales/no/assets.json';
import noEditOrganization from './locales/no/organizationEdit.json';
import noQuestionAndAnswers from './locales/no/questionsAndAnswers.json';

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    fallbackLng: 'en',
    debug: true,
    resources: {
      en: {
        product: enProductTranslation,
        onboarding: enOnboardingTranslation,
        layoutComponents: enLayoutComponents,
        apiErrors: enApiErrors,
        globalComponents: enGlobalComponents,
        bundle: enBundleComponentTranslation,
        shop: enShopTranslation,
        approval: enApprovalComponentTranslation,
        orders: enOrdersTranslation,
        authentication: enAuthentication,
        phoneNumberVerification: enPhoneNumberVerification,
        assets: enAssets,
        editOrganization: enEditOrganization,
        questionsAndAnswers: enQuestionAndAnswers,
      },
      no: {
        product: noProductTranslation,
        onboarding: noOnboardingTranslation,
        layoutComponents: noLayoutComponents,
        apiErrors: noApiErrors,
        globalComponents: noGlobalComponents,
        bundle: noBundleComponentTranslation,
        shop: noShopTranslation,
        approval: noApprovalComponentTranslation,
        orders: noOrdersTranslation,
        authentication: noAuthentication,
        phoneNumberVerification: noPhoneNumberVerification,
        assets: noAssets,
        editOrganization: noEditOrganization,
        questionsAndAnswers: noQuestionAndAnswers,
      },
    },
  });

export const i18n = i18next;
